import { RouterProvider } from "react-router-dom";
import RoutesConfig from "./routesConfig";

function App() {
  const updateFavicon = (iconPath) => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = iconPath;
  };
  if (window.location.href.split("/")[3] == "bses") {
    document.title = "BSES";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/UNIONBANK_single.svg"
    );
  }
  else if (window.location.href.split("/")[3] == "cbdt") {
    document.title = "GST | Payment";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/UNIONBANK_single.svg"
    );
  }
  else if (window.location.href.split("/")[3] == "emeter") {
    document.title = "VAS-EMETER";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/logo/favicon.png"
    );
  }
  else if (window.location.href.split("/")[3] == "APCPDCL") {
    document.title = "APCPDCL";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/cpdcl_logo.svg"
    );
  }
  else if (window.location.href.split("/")[3] == "TGNPDCL") {
    document.title = "TGNPDCL Bill Payment Online | Pay Telangana Electricity Bill";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tel-north-main-logo.svg"
    );
    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Pay TGNPDCL electricity bill online in Telangana with Easebuzz. Enjoy fast, secure payments with multiple options and instant confirmation.";
  }
  else if (window.location.href.split("/")[3] == "TGSPDCL") {
    document.title = "TGSPDCL | Bill Pay";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tgspdcl-logo.jpg"
    );
  }
  else if (window.location.href.split("/")[3] == "BMC") {
    document.title = "BMC Mumbai | Property Tax";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/bmc_logo.png"
    );
  }
  else if (window.location.href.split("/")[3] == "reclimited") {
    document.title = "REC Limited";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/REC_Logo.jpg"
    );
  }
  else {
    document.title = "EaseBuzz";
    updateFavicon(
      "https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Easebuzz_Logo.svg"
    );
  }
  return <RouterProvider router={RoutesConfig} />;
}

export default App;
